<template>
  <div>
    <div
      v-for="(p, index) in patientList"
      :key="index"
      :class="['patient', p.patient_id.toString() === disabledPatientId ? 'disabled': 'cursor-pointer']"
      @mousedown="handleClickSearchedPatient(p)"
    >
      <SearchPatientListItem
        :name="highlightMatch(p)"
        :gender="p.patient_gender"
        :dob="formatBirthdate(p.patient_birthdate)" 
        :is-disabled="p.patient_id.toString() === disabledPatientId"
      />
    </div>
  </div>
</template>

<script>
import SearchPatientListItem from "./SearchPatientListItem.vue";
export default {
  emits: ["clickSearchedPatient","handlePatient"],
  components: {
    SearchPatientListItem
  },
  props: {
    patientList: {
      type: Array,
      default: () => []
    },
    inputPatientName: {
      type: String,
      default: "",
    },
    disabledPatientId: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      formattedPatient: {}
    }
  },

  methods: { 
    // highlight matched characters in each filtered patient name
    highlightMatch(patientObj){
      let text = "";
      if (patientObj.patient_first_name)
        text += patientObj.patient_first_name;
      if (patientObj.patient_middle_name)
        text += " " + patientObj.patient_middle_name;
      if (patientObj.patient_last_name)
        text += " " + patientObj.patient_last_name;
      // escape special characters in inputPatientName if any
      let pattern = "[" + this.inputPatientName.replace(/[.*+?^${}()/\\[\]-]/g, "\\$1") + "]";
      return text.replace(new RegExp(pattern, 'gi'), match => {
        return '<strong>' + match + '</strong>';
      });
    },
    
    formatBirthdate(birthdate) {
      if (!birthdate) {
        return "";
      }      
      let [year, month, day] = birthdate.split("-");
      return month + "/" + day + "/" + year;
    },

    handleClickSearchedPatient(p) {
      if (p.patient_id.toString() === this.disabledPatientId) {
        return;
      }
      this.$emit('clickSearchedPatient',p);
    }
  }
}
</script>
<style scoped>
.patient{
  height: 40px;
  padding-top: 8.5px;
  padding-left: 13.1px;
  color: #000000;
  font-size: 15px;
  letter-spacing: 0.43px;
  line-height: 18px;
}

.patient:hover {
  height: 40px;
  background: #F9FBFD;
}

.patient.disabled {
  height: 40px;
  background: #E6E6E6;
}

</style>